/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TourAgentInfo_tour = {
    readonly contactNumber: string | null;
    readonly fullname: string | null;
    readonly email: string | null;
    readonly profileImageURL: string | null;
    readonly " $refType": "TourAgentInfo_tour";
};
export type TourAgentInfo_tour$data = TourAgentInfo_tour;
export type TourAgentInfo_tour$key = {
    readonly " $data"?: TourAgentInfo_tour$data;
    readonly " $fragmentRefs": FragmentRefs<"TourAgentInfo_tour">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TourAgentInfo_tour",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileImageURL",
      "storageKey": null
    }
  ],
  "type": "AgentProfile",
  "abstractKey": null
};
(node as any).hash = '3bb43d1fb7049f7b004902e00d3490f0';
export default node;
